export default [{
  path: '/',
  redirect: '/home',
  component: resolve => require(['../components/pages/Header.vue'], resolve),
  children: [{
    path: '/home',
    name: 'Home',
    component: resolve => require(['../components/pages/Home.vue'], resolve),
  }, {
    path: '/setting',
    name: 'Setting',
    redirect: '/setting/updatePwd',
    component: resolve => require(['../components/pages/Setting.vue'], resolve),
    children: [{
      path: '/setting/adminAccount',
      name: 'adminAccount',
      components: {
        default: resolve => require(['../components/pages/AdminAccount.vue'], resolve),
      },
      meta: {
        title: '更换超级管理员'
      }
    }, {
      path: '/setting/subAccount',
      name: 'subAccount',
      components: {
        default: resolve => require(['../components/pages/SubAccount.vue'], resolve),
      },
      meta: {
        title: '设置子管理员'
      }
    }, {
      path: '/setting/updatePwd',
      name: 'updatePwd',
      components: {
        default: resolve => require(['../components/pages/UpdatePwd.vue'], resolve),
      },
      meta: {
        title: '修改管理密码'
      }
    }, , {
      path: '/setting/company',
      name: 'company',
      components: {
        default: resolve => require(['../components/pages/Company.vue'], resolve),
      },
      meta: {
        title: '考核评级设置'
      }
    }, {
      path: '/setting/schStatus',
      name: 'schStatus',
      components: {
        default: resolve => require(['../components/pages/SchStatus.vue'], resolve),
      },
      meta: {
        title: '设置排班状态'
      }
    }, {
      path: '/setting/cmpInfo',
      name: 'CmpInfo',
      components: {
        default: resolve => require(['../components/pages/CmpInfo.vue'], resolve),
      },
      meta: {
        title: '企业信息'
      }
    }, {
      path: '/setting/sku',
      name: 'SkuInfo',
      components: {
        default: resolve => require(['../components/pages/SkuInfo.vue'], resolve),
      },
      meta: {
        title: '产品信息'
      }
    }]
  }, {
    path: '/touch',
    name: 'Touch',
    redirect: '/touch/dept',
    component: resolve => require(['../components/pages/Touch.vue'], resolve),
    children: [{
      path: '/touch/dept',
      name: 'Dept',
      components: {
        default: resolve => require(['../components/pages/Dept.vue'], resolve),
      },
      meta: {
        title: '组织架构'
      }
    }, {
      path: '/touch/login-user',
      components: {
        default: resolve => require(['../components/pages/LoginUser.vue'], resolve),
      },
      meta: {
        title: '基础版'
      }
    }, {
      path: '/touch/contact',
      name: 'Contact',
      components: {
        default: resolve => require(['../components/pages/Contact.vue'], resolve),
      },
      meta: {
        title: '通讯录'
      }
    }, {
      path: '/touch/level',
      name: 'Level',
      components: {
        default: resolve => require(['../components/pages/Level.vue'], resolve),
      },
      meta: {
        title: '级别管理'
      }
    }, {
      path: '/touch/schedule',
      name: 'Schedule',
      components: {
        default: resolve => require(['../components/pages/Schedule.vue'], resolve),
      },
      meta: {
        title: '排班管理'
      }
    }, {
      path: '/touch/role',
      name: 'Role',
      components: {
        default: resolve => require(['../components/pages/Role.vue'], resolve),
      },
      meta: {
        title: '角色权限'
      }
    }, {
      path: '/touch/user',
      name: 'User',
      components: {
        default: resolve => require(['../components/pages/User.vue'], resolve),
      },
      meta: {
        title: '职员权限'
      }
    }, {
      path: '/touch/range',
      name: 'Range',
      components: {
        default: resolve => require(['../components/pages/Range.vue'], resolve),
      },
      meta: {
        title: '范围权限'
      }
    }, {
      path: '/touch/field',
      name: 'Field',
      components: {
        default: resolve => require(['../components/pages/Field.vue'], resolve),
      },
      meta: {
        title: '字段设置'
      }
    }, {
      path: '/touch/position',
      name: 'Position',
      components: {
        default: resolve => require(['../components/pages/Position.vue'], resolve),
      },
      meta: {
        title: '职位管理'
      }
    }, {
      path: '/loginlog',
      name: 'Loginlog',
      components: {
        default: resolve => require(['../components/pages/Loginlog.vue'], resolve),
      },
      meta: {
        title: '登录日志'
      }
    }, {
      path: '/optlog',
      name: 'Optlog',
      components: {
        default: resolve => require(['../components/pages/Optlog.vue'], resolve),
      },
      meta: {
        title: '操作日志'
      }
    }, {
      path: '/role',
      name: 'Role',
      components: {
        default: resolve => require(['../components/pages/Role.vue'], resolve),
      },
      meta: {
        title: '角色管理'
      }
    }, {
      path: '/tags',
      name: 'Tags',
      components: {
        default: resolve => require(['../components/pages/Tags.vue'], resolve),
      },
      meta: {
        title: '标签管理'
      }
    }, {
      path: '/user',
      name: 'User',
      components: {
        default: resolve => require(['../components/pages/User.vue'], resolve),
      },
      meta: {
        title: '用户管理'
      }
    }, {
      path: '/draft',
      name: 'Draft',
      components: {
        default: resolve => require(['../components/pages/Draft.vue'], resolve),
      },
      meta: {
        title: '公司草稿'
      }
    }]
  }]
},

{
  path: '/login',
  name: 'Login',
  component: resolve => require(['../components/pages/Login.vue'], resolve),
},
{
  path: '/login2',
  name: 'Login2',
  component: resolve => require(['../components/pages/Login2.vue'], resolve),
},
{
  path: '/404',
  component: resolve => require(['../components/pages/404.vue'], resolve)
},
{
  path: '*',
  redirect: '/404'
}
]



// WEBPACK FOOTER //
// ./src/router/routers.js